<template>
  <el-card class="box-card">
    <el-collapse-item name="2">
      <template slot="title">
        <span class="title"> {{ $t("message.title.cover") }}</span>
      </template>

      <el-collapse-transition>
        <div class="page-index">
          <ul>
            <li v-for="(item,e) in cover" :key="item.index">
              <div>
                <div class="left"   :style="{'backgroundColor':bgc[e%5]}" >
                  <i class="icon-cover" :class="iconType[item.type-1]" :style="{'color':iconColor[e%5]}"></i>
                </div>
                <div>
                  <span>{{ item.name }}</span
                  ><br /><span>{{ item.val }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-transition>
    </el-collapse-item>
  </el-card>
</template>

<script>
export default {
  props: ["cover"],
  data() {
    return {
      // iconType: "el-icon-date",
      iconType:["el-icon-tickets","el-icon-copy-document","el-icon-s-custom","el-icon-date",],
      bgc: [
        "rgba(255, 188, 0,0.2)" ,
        "rgba(65, 153, 249,0.2)" ,
        "rgba(105, 103, 236,0.2)" ,
        "rgba(73, 194, 159,0.2)" ,
        "rgba(195, 74, 229,0.2)" ,
      ],
      iconColor: [
        "rgba(255, 188, 0)" ,
        "rgba(65, 153, 249)" ,
        "rgba(105, 103, 236)" ,
        "rgba(73, 194, 159)" ,
        "rgba(195, 74, 229)" ,
      ],
    };
  },
  methods: {},
  created(){
    console.log(this.cover);
  },
};
</script>

<style  scoped>
.left {
  width: 55px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 20px;
  float: left;
  /* border: #3ea0fb 1px solid; */
  /* background-color: rgba(62, 160, 251, 0.2); */
  /*  
  #ffbc00 255, 188, 0   橙黄
  #4199f9 65, 153, 249  蓝色
  #6967ec 105, 103, 236 紫色
  #49c29f 73, 194, 159 绿
  #fd5576 253, 85, 118 红
  #c34ae5 195, 74, 229
   */
  border-radius: 28px;
  margin-right: 25px;
  opacity: 0.8;
}
.icon-cover {
  color: #3ea0fb;
  text-align: center;
  line-height: 55px;
  opacity: 1;
}
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}
.page-index {
  /* width: 100%; */
  max-height: 360px;
  overflow: auto;
  margin-top: 25px;
  /* width: 108%; */
}

.page-index ul {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 96%;
  margin-left: 25px;
}

.page-index ul li {
  width: 23%;
  height: 80px;
  margin-top: 5px;
  margin-right: 2%;
  float: left;
  font-size: 10px;
}

.page-index ul li span:nth-child(1) {
  color: #272727;
  font-size: 16px;
  line-height: 26px;
  font-weight: bold;
}

.page-index ul li span:nth-child(3) {
  font-size: 14px;
  line-height: 24px;
  color: #606266;
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>